<template>
  <van-row id="forum" class="flex-column">
    <!-- NavBar part -->
    <mynavbar></mynavbar>

    <!-- cell part -->
    <van-skeleton class="mt-4rem" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <van-divider class="mt-4rem" style="font-size: 1.2rem;">{{title}} &sdot; 相关项目</van-divider>
    </van-skeleton>
    <van-skeleton style="margin-top: 2rem;" :row="5" :loading="sloading" id="skeleton-cell">
      <van-row v-if="articles1.length > 0">
        <van-cell-group title="">
          <van-cell :title="item.title.length>25?item.title.substring(0,25)+'...':item.title" is-link :url="detailUrl + item.id" v-for="(item,index) in articles1" :key="item.id" />
        </van-cell-group>
        <van-row style="padding: 1rem 0; text-align: center; color: gray;">
          <van-button type="default" size="small" round  :url="categoryUrl + idChannel" style="color: gray; padding: 0 2rem;">查看更多</van-button>
        </van-row>
      </van-row>
      <van-empty v-else description="暂无记录" />
    </van-skeleton>
    <!-- <van-skeleton :row="1" :loading="sloading" v-for="index in 4" :key="index" title></van-skeleton> -->

    <!-- ad banner -->
    <van-skeleton style="margin-top: 2rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-ad">
      <van-image src="/static/img/adbanner01.png" height="4rem" fit="cover"></van-image>
    </van-skeleton>

    <!-- video part -->
    <van-skeleton style="margin-top: 1rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <van-divider style="font-size: 1.2rem;">视频中心</van-divider>
    </van-skeleton>
    <van-skeleton style="margin-top: 0.2rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title"></van-skeleton>

    <van-skeleton title avatar avatar-shape="square" avatar-size="100px" :row="2" :loading="sloading" style="margin-top: 3rem;">
      <van-tabs v-model="active" @click="tabClick">
        <van-tab :title="item.name" :name="item.id" v-for="(item,index) in category_num" :key="index">
          <van-list
            v-if="articles2.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
            style="padding: 0.5rem;"
          >
            <van-cell :title="item.title" :label="item.modifyTime" :url="item.url" is-link center v-for="(item,index) in articles2" :key="item.id" />
            <!-- <van-card
              v-for="(item,index) in articles2" :key="item.id"
              :title="item.title"
              class="goods-card"
              :thumb="item.coverUrl"
              @click="openDetails(item.id)"
            >
              <template #footer>
                <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
              </template>
            </van-card> -->
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
        <!-- <van-tab title="专题论坛">专题论坛</van-tab>
        <van-tab title="临床讲座">临床讲座</van-tab>
        <van-tab title="病例讨论">病例讨论</van-tab> -->
      </van-tabs>
    </van-skeleton>


    <!-- footer part -->
    <!-- <myfooter></myfooter> -->

  </van-row>
</template>

<script>
import navbar from '@/view/navbar/navbar'
// import footer from '@/view/footer/footer'

const axios = require('axios')

export default {
  name: 'forum',
  components: {
    'mynavbar' : navbar,
    // 'myfooter' : footer
  },
  data () {
    return {
      active: 0,
      idChannel: 0,
      title: '',
      type: '',
      n: 1,
      currPage: 1,
      pageSize: 10,
      sloading: true,
      loading: false,
      finished: false,
      tabId: 0,
      articles1: [],
      articles2: [],
      category_all: [],
      category_num: [],
      article1: [],
      article2: [],
      article3: [],
      article4: [],
      article5: [],
      article6: [],
      detailUrl: '/article/details/',
      categoryUrl: '/article/category/',
    }
  },
  created() {
    this.type = this.$route.params.type
  },
  mounted() {
    let that = this
    // 获取论坛相关项目
    if(that.type == "pediatric") {
      that.title = '儿科论坛'
      that.idChannel = 6
      that.n = 1
    }else if(that.type == "healthy") {
      that.title = '儿童健康讲坛'
      that.idChannel = 7
      that.n = 2
    }
    // 获取相关项目
    axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=5&idChannel='+that.idChannel+'&sort=id&order=desc')
      .then(function (response) {
        if (response.data.success && response.data.data.records.length > 0) {
          that.articles1 = response.data.data.records
          for (var index in that.articles1) {
            const item = that.articles1[index]
            // item.digest = item.title
            item.title = item.title.length > 20 ? item.title.substring(0, 20) + '...' : item.title
            item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
          }
          // console.log(that.articles1)
        }
      }
    )

    // 视频中心栏目列表
    axios.get(that.global.apiUrl + '/web/channel/getListByPid?pid=9')
      .then(function (response) {
        // console.log(response.data.data)
        if (response.data.success && response.data.data.length > 0) {
          // 读取所有栏目一级和二级
          for(var i=0; i<response.data.data.length; i++) {
            that.category_all.push(response.data.data[i])
            // if(response.data.data[i].children) {
            //   for(var j=0; j<response.data.data[i].children.length; j++) {
            //      that.category_all.push(response.data.data[i].children[j])
            //   }
            // }
          }
          // console.log(that.category_all)
          // 分析栏目
          // 获取所有num<0的栏目列表
          for(var index in that.category_all) {
            if(that.category_all[index].num == -(that.n)) {
              that.category_num.push(that.category_all[index])
            }
          }
          // 以num字段排序0-6
          that.category_num.sort(function(a, b){
            var x = a["num"]
            var y = b["num"]
            return x - y
          })
          // 获取第一个tab的视频文章列表
          that.getArticles(that.category_num[0].id, that.currPage)

          // console.log(that.category_num)
          // for(var index in that.category_num) {
          //   axios.get(that.global.apiUrl + '/web/article/list?page=1&limit=10&idChannel='+that.category_num[index].id+'&sort=id&order=desc')
          //     .then(function (response) {
          //       if (response.data.success && response.data.data.records.length > 0) {
          //         that.articles2[index] = response.data.data.records
          //         // console.log(that.articles2[index])
          //         for (var i in that.articles2[index]) {
          //           const item = that.articles2[index][i]
          //           // item.digest = item.title
          //           // item.title = item.title.length > 20 ? item.title.substring(0, 20) + '...' : item.title
          //           item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
          //         }
          //         console.log(that.articles2[index])
          //       }
          //     }
          //   )
          // }
          // console.log('categorys:' + that.articles2.length)
          // for(var index in that.category_all) {
          //   // category_01
          //   if(that.category_all[index].num == 1) {
          //     that.category_01 = that.category_all[index]
          //   }
          //   // category_02
          //   if(that.category_all[index].num == 2) {
          //     that.category_02 = that.category_all[index]
          //   }
          //   // category_03
          //   if(that.category_all[index].num == 3) {
          //     that.category_03 = that.category_all[index]
          //   }
          //   // category_04
          //   if(that.category_all[index].num == 4) {
          //     that.category_04 = that.category_all[index]
          //   }
          //   // category_05
          //   if(that.category_all[index].num == 5) {
          //     that.category_05 = that.category_all[index]
          //   }
          //   // category_06
          //   if(that.category_all[index].num == 6) {
          //     that.category_06 = that.category_all[index]
          //   }
          //   // category_07
          //   if(that.category_all[index].num == 7) {
          //     that.category_07 = that.category_all[index]
          //   }
          //   // category_08
          //   if(that.category_all[index].num == 8) {
          //     that.category_08 = that.category_all[index]
          //   }
          //   // category_09
          //   if(that.category_all[index].num == 9) {
          //     that.category_09 = that.category_all[index]
          //   }
          //   // category_10
          //   if(that.category_all[index].num == 10) {
          //     that.category_10 = that.category_all[index]
          //   }
          // }

        }
      }
    )
    // if(that.n == 1) {

    // }

  },
  methods: {
    // 加载更多
    onLoad() {
      console.log("加载更多")
      this.currPage = this.currPage + 1
      this.getArticles(this.tabId,this.currPage)
    },
    // tab点击触发
    tabClick (name,title) {
      this.currPage = 1
      this.loading = true
      this.finished = false
      this.tabId = name
      this.articles2 = []
      this.getArticles(name,this.currPage)
    },
    // 获取视频文章列表
    getArticles (id,page) {
      let that = this
      // axios.get(that.global.apiUrl + '/web/article/list?page='+page+'&limit=10&idChannel='+id+'&sort=id&order=desc')
      axios.get(that.global.apiUrl + '/web/linkto/list?page='+page+'&limit=10&idChannel='+id+'&sort=id&order=desc')
        .then(function (response) {
          if (response.data.success && response.data.data.records.length > 0) {
            // var articles = response.data.data.records
            // for (var i in articles) {
            //   const item = articles[i]
            //   // item.digest = item.title
            //   // item.title = item.title.length > 20 ? item.title.substring(0, 20) + '...' : item.title
            //   item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img

            //   that.articles2.push(articles[i])
            // }
            that.articles2 = response.data.data.records
            // 加载状态结束
            that.loading = false
            that.sloading = false
            // console.log(that.articles2)
          }else {
            that.sloading = false
            that.loading = false
            that.finished = true
          }
        }
      )
    },
    // 打开详情页
    openDetails (id) {
      // console.log(id)
      this.$router.push({ path:'/article/details/'+id })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/forum/forum.vue